import { render, staticRenderFns } from "./CompetitionListDefaultLayout.vue?vue&type=template&id=1f26a88c&scoped=true"
import script from "./CompetitionListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f26a88c",
  null
  
)

export default component.exports